import { motion } from "framer-motion";
import React from "react";

type Props = {
  children: React.ReactNode;
  /** Extra delay (seconds) for staggering siblings */
  delay?: number;
  className?: string;
};

/**
 * Fade + translate-up on scroll into view. React/framer-motion replacement for
 * the design mockups' hand-rolled `.reveal` rAF loops. Animates once.
 */
const Reveal = ({ children, delay = 0, className = "" }: Props) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.7, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
